<button class="button custom-nav-button" [class.is-bold]="isBold" audio-slug [slug]="text">
    <!-- Separate BG and FG to apply hover effects only to background -->
    <div style="position: absolute; width:100%; height: 100%" class="button-bg" [ngStyle]="getBgStyle()"></div> 
    <div class="button-fg" [ngStyle]="getFgStyle()">
        <i *ngIf="isPrev" class="fas fa-chevron-left" aria-hidden="true"></i><tra class="button-txt" [slug]="text"></tra><i *ngIf="!isPrev" class="fas" [class.fa-chevron-right]="!showStar" [class.fa-star]="showStar" aria-hidden="true"></i>
    </div>
</button>
